export const categories = [
  {
    slug: 'dongzuo',
    name: '动作片',
    description: '热血激燃的动作大片，拳拳到肉的精彩对决',
    icon: 'ri-sword-line',
  },
  {
    slug: 'xiju',
    name: '喜剧片',
    description: '轻松搞笑的欢乐佳作，让你笑到停不下来',
    icon: 'ri-emotion-laugh-line',
  },
  {
    slug: 'aiqing',
    name: '爱情片',
    description: '浪漫动人的爱情故事，甜蜜温馨的情感之旅',
    icon: 'ri-heart-line',
  },
  {
    slug: 'kehuan',
    name: '科幻片',
    description: '脑洞大开的科幻巨制，探索未来的无限可能',
    icon: 'ri-rocket-line',
  },
  {
    slug: 'kongbu',
    name: '恐怖片',
    description: '惊悚刺激的恐怖体验，挑战你的心理极限',
    icon: 'ri-ghost-line',
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    description: '精彩纷呈的热播剧集，追剧达人的不二之选',
    icon: 'ri-tv-line',
  },
  {
    slug: 'dongman',
    name: '动漫',
    description: '人气动漫全收录，二次元世界的视听盛宴',
    icon: 'ri-movie-line',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    description: '热门综艺一网打尽，欢乐时光从此开始',
    icon: 'ri-live-line',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    description: '真实世界的精彩记录，开阔视野的知识之旅',
    icon: 'ri-camera-lens-line',
  },
];

export const movies = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'kehuan',
    year: 2026,
    rating: 9.2,
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20film%20poster%2C%20astronaut%20on%20distant%20planet%20with%20orange%20and%20blue%20nebula%20sky%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20movie%20poster%20style%2C%20deep%20space%20background%20with%20stars%2C%20warm%20golden%20highlight%20on%20helmet%20visor&width=600&height=800&seq=movie-scifi-01&orientation=portrait',
    description: '太阳急速老化，人类面临前所未有的生存危机。联合政府启动"流浪地球计划"第三阶段，人类命运再次悬于一线。',
    tags: ['科幻', '灾难', '冒险'],
    duration: '148分钟',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健'],
  },
  {
    id: 2,
    title: '封神第二部',
    category: 'dongzuo',
    year: 2025,
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20film%20poster%2C%20ancient%20warrior%20in%20golden%20armor%20with%20flowing%20red%20cape%2C%20epic%20battle%20scene%20background%20with%20fire%20and%20smoke%2C%20dramatic%20cinematic%20lighting%2C%20dark%20atmospheric%20sky%2C%20movie%20poster%20style&width=600&height=800&seq=movie-action-01&orientation=portrait',
    description: '商朝末年，纣王无道，天下大乱。姜子牙率众神将伐纣，一场惊天动地的神魔大战即将展开。',
    tags: ['动作', '奇幻', '神话'],
    duration: '156分钟',
    director: '乌尔善',
    cast: ['费翔', '黄渤', '于适'],
  },
  {
    id: 3,
    title: '你好，李焕英2',
    category: 'xiju',
    year: 2025,
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20heartwarming%20comedy%20film%20poster%2C%20mother%20and%20daughter%20embracing%20in%20sunlit%20rural%20field%2C%20warm%20nostalgic%20atmosphere%2C%20soft%20golden%20hour%20lighting%2C%20gentle%20smiles%2C%80s%20Chinese%20village%20background%2C%20emotional%20and%20touching%20tone&width=600&height=800&seq=movie-comedy-01&orientation=portrait',
    description: '贾晓玲再次穿越时空，这次她来到了母亲年轻时的八十年代，一段笑中带泪的亲情故事再度上演。',
    tags: ['喜剧', '亲情', '时空穿越'],
    duration: '132分钟',
    director: '贾玲',
    cast: ['贾玲', '张小斐', '沈腾'],
  },
  {
    id: 4,
    title: '长津湖之水门桥2',
    category: 'dongzuo',
    year: 2025,
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20war%20film%20poster%2C%20soldiers%20marching%20through%20heavy%20snow%20in%20mountain%20battlefield%2C%20determined%20expressions%2C%20cold%20blue%20and%20white%20color%20palette%2C%20cinematic%20composition%2C%20dramatic%20winter%20lighting%2C%20epic%20scale&width=600&height=800&seq=movie-war-01&orientation=portrait',
    description: '志愿军战士们在极端严寒中继续坚守阵地，用血肉之躯筑起钢铁长城，谱写一曲可歌可泣的英雄赞歌。',
    tags: ['战争', '历史', '动作'],
    duration: '160分钟',
    director: '陈凯歌',
    cast: ['吴京', '易烊千玺', '段奕宏'],
  },
  {
    id: 5,
    title: '深海2',
    category: 'dongman',
    year: 2026,
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%2C%20magical%20underwater%20world%20with%20colorful%20coral%20reefs%20and%20bioluminescent%20creatures%2C%20young%20girl%20diving%20through%20deep%20ocean%2C%20dreamlike%20atmosphere%2C%20vibrant%20blues%20and%20purples%2C%20particle%20effects&width=600&height=800&seq=movie-anime-01&orientation=portrait',
    description: '参宿再次潜入奇幻深海世界，这一次她要寻找传说中的深海之心，拯救正在消逝的梦幻王国。',
    tags: ['动画', '奇幻', '冒险'],
    duration: '122分钟',
    director: '田晓鹏',
    cast: ['苏鑫', '王亭文'],
  },
  {
    id: 6,
    title: '热烈2',
    category: 'xiju',
    year: 2025,
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20dance%20film%20poster%2C%20street%20dancer%20performing%20dynamic%20breakdance%20move%20under%20neon%20city%20lights%2C%20energetic%20vibrant%20colors%2C%20motion%20blur%20effect%2C%20urban%20night%20background%2C%20youthful%20and%20passionate%20atmosphere&width=600&height=800&seq=movie-dance-01&orientation=portrait',
    description: '街舞少年陈烁在全国大赛后迎来新的挑战，他要带领团队走向国际舞台，用舞蹈证明自己的梦想。',
    tags: ['喜剧', '舞蹈', '励志'],
    duration: '128分钟',
    director: '大鹏',
    cast: ['王一博', '黄渤', '刘敏涛'],
  },
  {
    id: 7,
    title: '长安三万里2',
    category: 'dongman',
    year: 2026,
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20animated%20film%20poster%2C%20ancient%20Tang%20Dynasty%20poet%20in%20traditional%20robe%20riding%20horse%20through%20mountain%20landscape%2C%20ink%20wash%20painting%20style%2C%20golden%20sunset%20sky%2C%20classical%20Chinese%20aesthetic%2C%20poetic%20atmosphere&width=600&height=800&seq=movie-history-01&orientation=portrait',
    description: '以诗仙李白的传奇一生为主线，展现盛唐气象和中华诗词文化的璀璨光辉，一幅壮丽的历史画卷徐徐展开。',
    tags: ['动画', '历史', '诗词'],
    duration: '168分钟',
    director: '谢君伟',
    cast: ['杨天翔', '凌振赫'],
  },
  {
    id: 8,
    title: '消失的她2',
    category: 'kongbu',
    year: 2025,
    rating: 8.1,
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20Chinese%20thriller%20film%20poster%2C%20mysterious%20woman%20silhouette%20in%20rainy%20night%20city%20street%2C%20reflection%20in%20puddle%2C%20dark%20and%20moody%20atmosphere%2C%20neon%20reflections%2C%20psychological%20tension%2C%20film%20noir%20style&width=600&height=800&seq=movie-thriller-01&orientation=portrait',
    description: '一位心理医生接手了一个离奇的失踪案，随着调查深入，她发现真相远比想象中更加骇人听闻。',
    tags: ['悬疑', '惊悚', '犯罪'],
    duration: '135分钟',
    director: '陈思诚',
    cast: ['朱一龙', '倪妮', '文咏珊'],
  },
  {
    id: 9,
    title: '我们一起摇太阳2',
    category: 'aiqing',
    year: 2026,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20romantic%20film%20poster%2C%20young%20couple%20standing%20on%20rooftop%20at%20sunset%2C%20warm%20golden%20light%2C%20city%20skyline%20background%2C%20intimate%20and%20tender%20moment%2C%20soft%20lens%20flare%2C%20dreamy%20romantic%20atmosphere&width=600&height=800&seq=movie-romance-01&orientation=portrait',
    description: '两个身患重病的年轻人在医院相遇，他们约定一起面对生命的挑战，用爱和勇气摇醒沉睡的太阳。',
    tags: ['爱情', '治愈', '励志'],
    duration: '131分钟',
    director: '韩延',
    cast: ['彭昱畅', '李庚希'],
  },
  {
    id: 10,
    title: '满江红2',
    category: 'dongzuo',
    year: 2025,
    rating: 8.4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20film%20poster%2C%20ancient%20Chinese%20courtyard%20with%20red%20lanterns%2C%20soldiers%20in%20traditional%20armor%2C%20dramatic%20chiaroscuro%20lighting%2C%20dark%20conspiracy%20theme%2C%20classical%20architecture%20background%2C%20tense%20atmosphere&width=600&height=800&seq=movie-period-01&orientation=portrait',
    description: '南宋绍兴年间，秦桧率兵与金国会谈。一桩离奇命案打破了平静，背后竟隐藏着惊天秘密。',
    tags: ['动作', '悬疑', '历史'],
    duration: '142分钟',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '雷佳音'],
  },
  {
    id: 11,
    title: '庆余年第二季',
    category: 'dianshiju',
    year: 2025,
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20TV%20drama%20poster%2C%20handsome%20scholar%20in%20ancient%20Chinese%20robe%20holding%20sword%2C%20palace%20background%20with%20golden%20details%2C%20regal%20and%20mysterious%20atmosphere%2C%20dramatic%20cinematic%20lighting%2C%20epic%20scale&width=600&height=800&seq=tv-drama-01&orientation=portrait',
    description: '范闲在庆国朝堂步步为营，他周旋于各方势力之间，一边追寻母亲死亡的真相，一边守护在意的人。',
    tags: ['古装', '权谋', '剧情'],
    duration: '45分钟/集 共36集',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明'],
  },
  {
    id: 12,
    title: '三体',
    category: 'dianshiju',
    year: 2026,
    rating: 9.4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%2C%20three%20suns%20hanging%20in%20alien%20sky%20over%20desolate%20landscape%2C%20mysterious%20cosmic%20vibe%2C%20dark%20and%20vast%20universe%2C%20minimalist%20design%2C%20deep%20space%20mystery&width=600&height=800&seq=tv-scifi-01&orientation=portrait',
    description: '纳米科学家汪淼被卷入一场跨越星际的阴谋，人类文明面临前所未有的考验，宇宙的真相令人不寒而栗。',
    tags: ['科幻', '悬疑', '剧情'],
    duration: '60分钟/集 共30集',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾'],
  },
  {
    id: 13,
    title: '奔跑吧第十季',
    category: 'zongyi',
    year: 2026,
    rating: 8.0,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20celebrities%20running%20and%20laughing%20on%20sunny%20outdoor%20set%2C%20colorful%20and%20energetic%20atmosphere%2C%20game%20show%20vibe%2C%20bright%20and%20cheerful%20lighting%2C%20fun%20and%20entertaining%20composition&width=600&height=800&seq=variety-01&orientation=portrait',
    description: '跑男团再次集结，全新游戏挑战，爆笑不断的户外竞技真人秀，每周五晚欢乐上线。',
    tags: ['综艺', '户外', '竞技'],
    duration: '90分钟/期',
    director: '姚译添',
    cast: ['李晨', '郑恺', '杨颖', '白鹿'],
  },
  {
    id: 14,
    title: '地球脉动：中国篇',
    category: 'jilupian',
    year: 2025,
    rating: 9.6,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20nature%20documentary%20poster%2C%20majestic%20snow%20leopard%20on%20rocky%20mountain%20peak%20in%20Tibet%2C%20dramatic%20landscape%20with%20clouds%2C%20pristine%20wilderness%2C%20breathtaking%20natural%20scenery%2C%20golden%20sunrise%20lighting&width=600&height=800&seq=doc-nature-01&orientation=portrait',
    description: '从青藏高原到南海之滨，从东北雪原到西南雨林，全景展现中国大地的壮美自然与丰富生态。',
    tags: ['纪录片', '自然', '地理'],
    duration: '50分钟/集 共8集',
    director: 'BBC Studios',
    cast: ['解说：刘琮'],
  },
  {
    id: 15,
    title: '哪吒之魔童降世2',
    category: 'dongman',
    year: 2026,
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%2C%20young%20rebellious%20warrior%20with%20flaming%20hair%20surrounded%20by%20fire%20and%20lightning%2C%20ancient%20Chinese%20mythological%20theme%2C%20dynamic%20action%20pose%2C%20red%20and%20gold%20color%20palette%2C%20epic%20cinematic%20style&width=600&height=800&seq=movie-fantasy-02&orientation=portrait',
    description: '哪吒在经历天劫之后重获新生，他要在天命与自我之间做出最终抉择，一场撼动三界的大战即将爆发。',
    tags: ['动画', '神话', '动作'],
    duration: '135分钟',
    director: '饺子',
    cast: ['吕艳婷', '囧森瑟夫', '陈浩'],
  },
  {
    id: 16,
    title: '我和我的父辈2',
    category: 'xiju',
    year: 2025,
    rating: 8.2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20family%20drama%20film%20poster%2C%20multi-generation%20family%20portrait%20with%20warm%20smiles%2C%20nostalgic%20Chinese%20home%20setting%2C%20golden%20afternoon%20light%20through%20window%2C%20heartwarming%20and%20emotional%20atmosphere%2C%20realistic%20photographic%20style&width=600&height=800&seq=movie-family-01&orientation=portrait',
    description: '四个不同年代的父辈故事，串联起中国家庭的温暖记忆，每一代人的奋斗与传承，都是最美的中国故事。',
    tags: ['喜剧', '家庭', '剧情'],
    duration: '145分钟',
    director: '吴京',
    cast: ['吴京', '章子怡', '徐峥', '沈腾'],
  },
];